
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webshop",
      function () {
        return require("private-next-pages/webshop/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webshop"])
      });
    }
  